import React from 'react';
import './ConfirmationDialog.css'

const ConfirmationDialog = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="dialog">
      <div className="dialog-content">
        <p>{message}</p>
        <button onClick={onConfirm}>Yes</button>
        <button onClick={onCancel}>No</button>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
